import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3dl4lzr37lpxg">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="nv0zhx4tgw79" />}
      <TopBar data-id="element-2" data-mp="stufbw7kszal" />
      <main data-id="element-3" data-mp="stc8y6r794oy">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="st2iki28sviq" />
        <StatsBand data-id="element-5" data-mp="3684hdq2uasw" />
        <BeforeAfter data-id="element-6" data-mp="35ox2qy1z4t4" />
        <MeetingSelector data-id="element-7" data-mp="356wji4cy4fe" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="38kw6ilmzzj5" />
        <SolutionSection data-id="element-9" data-mp="3ubrfeek9e61c" />
        <YearPlanSection data-id="element-10" data-mp="3uc9nq9k74apm" />
        <MeetingsList data-id="element-11" data-mp="3uf5gljh6s977" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-12" data-mp="d57g95652mk4" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-13" data-mp="d3wbp34vdary" />
        <GuaranteeSection data-id="element-14" data-mp="85bbh3pmar3i" />
        <FaqSection data-id="element-15" data-mp="864a1hefaaak" />
        <FinalCta data-id="element-16" data-mp="83i2vivg1wsv" />
      </main>
      <Footer data-id="element-17" data-mp="3gl4qfe4avuig" />
      <StickyCta data-id="element-18" data-mp="3gklau424hi7l" />
    </div>;
}